import axios from 'axios';
import { serviceUrl } from '../../../App';

export const getTeams = () => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `team/team-trade-assingment-tree`
  );
};
export const getTeamsDetail = (team_id: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `team/one-detail?team_id=` + team_id
  );
};
export const teamUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `team/update`, obj, {
    headers,
  });
};
export const teamDelete = (obj: Object) => {
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `team/delete`, obj);
};
export const createTeam = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(process.env.REACT_APP_API_GLOBAL_URL + `team/add`, obj, {
    headers,
  });
};
